import { render } from "./LessonDetailCollapse.vue?vue&type=template&id=0af19271"
import script from "./LessonDetailCollapse.vue?vue&type=script&lang=js"
export * from "./LessonDetailCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__